import { profile } from "../context/profile";

export const StaffRoles = [
  "principal",
  "admin",
  "director",
  "finance",
  "hr",
  "registrar",
  "teacher",
  "headTeacher",
  "encoder",
  "support",
  "counselor",
  "librarian",
  "supervisor",
];

const roleDisplayNames = {
  principal: "Principal",
  admin: "Admin",
  director: "Director",
  finance: "Finance",
  hr: "HR",
  registrar: "Registrar",
  teacher: "Teacher",
  headTeacher: "Head Teacher",
  encoder: "Encoder",
  support: "Support",
  counselor: "Counselor",
  librarian: "Librarian",
  supervisor: "Supervisor",
};

export const brandNameProvider = () => {
  if (roleDisplayNames[profile.role]) {
    return roleDisplayNames[profile.role];
  } else if (profile.role !== null) {
    return profile.role;
  } else {
    return "Askuala Link";
  }
};
